import { useCallback, useRef } from 'react';
import { apiFetch } from '../utils/api';

function buildAvatar(name) {
  return name
    ? name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .substring(0, 2)
        .toUpperCase()
    : '??';
}

export function useUpdateContact(setContacts, setConversations) {
  const revertTagsRef = useRef(null);

  const handleUpdateContact = useCallback(
    async (contactId, updates) => {
      if (!contactId) return;
      const payload = {};
      if (updates.name !== undefined || updates.nome !== undefined) {
        payload.name = (updates.name ?? updates.nome)?.trim() ?? '';
      }
      if (updates.phone !== undefined || updates.telefone !== undefined) {
        payload.phone = (updates.phone ?? updates.telefone)?.trim() ?? undefined;
      }
      if (updates.email !== undefined) {
        payload.email = updates.email?.trim() ?? undefined;
      }
      if (updates.status !== undefined) {
        payload.status = updates.status?.trim() ?? undefined;
      }
      const tagsPayload =
        updates.tags !== undefined ? (Array.isArray(updates.tags) ? updates.tags : []) : undefined;
      if (tagsPayload !== undefined) payload.tags = tagsPayload;
      if (Object.keys(payload).length === 0) return;

      const safeTags = Array.isArray(tagsPayload) ? tagsPayload : [];

      if (payload.tags) {
        setContacts((prev) => {
          const prevContact = prev.find((c) => c.id === contactId);
          revertTagsRef.current = Array.isArray(prevContact?.tags) ? prevContact.tags : [];
          return prev.map((c) => (c.id === contactId ? { ...c, tags: safeTags } : c));
        });
      }

      try {
        const res = await apiFetch(`/contacts/${contactId}`, {
          method: 'PATCH',
          json: payload,
        });
        const updated = res.data ?? res;
        const contactForState = {
          ...updated,
          nome: updated.nome ?? updated.name,
          telefone: updated.telefone ?? updated.phone,
          tags: Array.isArray(updated.tags) ? updated.tags : safeTags,
        };
        setContacts((prev) => prev.map((c) => (c.id === contactId ? { ...c, ...contactForState } : c)));
        setConversations((prev) =>
          prev.map((c) =>
            c.contact_id === contactId
              ? {
                  ...c,
                  name: contactForState.nome || contactForState.name || c.name,
                  avatar: buildAvatar(contactForState.nome || contactForState.name || c.name),
                  phone: contactForState.telefone || contactForState.phone || c.phone,
                  email: contactForState.email || c.email,
                }
              : c
          )
        );
      } catch (e) {
        console.error('Erro ao atualizar contato', e);
        if (payload.tags && revertTagsRef.current) {
          const revertTags = revertTagsRef.current;
          revertTagsRef.current = null;
          setContacts((prev) => prev.map((c) => (c.id === contactId ? { ...c, tags: revertTags } : c)));
        }
      }
    },
    []
  );

  return handleUpdateContact;
}
